// Vendors
import styled from 'styled-components';
import { FoundationsCobrandedRegularTheme } from '@openbank/ziniaweb-ui-core-models';

const DefaultSkeletonComponentContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_250};
  width: 100%;
`;

DefaultSkeletonComponentContainer.displayName = 'DefaultSkeletonComponentContainer';

const LayoutStepsSkeletonContainer = styled.section`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: ${FoundationsCobrandedRegularTheme.spacing_300};
  width: 100%;
`;

LayoutStepsSkeletonContainer.displayName = 'LayoutStepsSkeletonContainer';

const TitlePageDefaultSkeletonComponent = styled.section`
  display: flex;
  width: ${FoundationsCobrandedRegularTheme.size_1083};
  height: ${FoundationsCobrandedRegularTheme.spacing_350};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

TitlePageDefaultSkeletonComponent.displayName = 'TitlePageDefaultSkeletonComponent';

const TitleStepDefaultSkeletonComponent = styled.section`
  display: flex;
  width: ${FoundationsCobrandedRegularTheme.size_1110};
  height: ${FoundationsCobrandedRegularTheme.size_300};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

TitleStepDefaultSkeletonComponent.displayName = 'TitleStepDefaultSkeletonComponent';

const NumberStepDefaultSkeletonComponent = styled.section`
  display: flex;
  width: ${FoundationsCobrandedRegularTheme.size_750};
  height: ${FoundationsCobrandedRegularTheme.size_250};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

NumberStepDefaultSkeletonComponent.displayName = 'NumberStepDefaultSkeletonComponent';

const HalfRowSkeleton = styled.section`
  display: flex;
  width: ${FoundationsCobrandedRegularTheme.size_1200};
  height: ${FoundationsCobrandedRegularTheme.size_250};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-self: stretch;
`;

HalfRowSkeleton.displayName = 'HalfRowSkeleton';

const ImageSkeleton = styled.section`
  margin: 0 auto;
`;

ImageSkeleton.displayName = 'ImageSkeleton';

const RowSkeleton = styled.section`
  display: flex;
  width: 100%;
  height: ${FoundationsCobrandedRegularTheme.spacing_300};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

RowSkeleton.displayName = 'RowSkeleton';

const QuarterRowSkeleton = styled.section`
  display: flex;
  width: ${FoundationsCobrandedRegularTheme.size_950};
  height: ${FoundationsCobrandedRegularTheme.size_250};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
QuarterRowSkeleton.displayName = 'QuarterRowSkeleton';

const SeparatorDefaultSkeletonComponent = styled.section`
  display: flex;
  width: 100%;
  height: ${FoundationsCobrandedRegularTheme.size_50};
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;
SeparatorDefaultSkeletonComponent.displayName = 'SeparatorDefaultSkeletonComponent';

export {
  DefaultSkeletonComponentContainer,
  HalfRowSkeleton,
  ImageSkeleton,
  LayoutStepsSkeletonContainer,
  NumberStepDefaultSkeletonComponent,
  QuarterRowSkeleton,
  RowSkeleton,
  SeparatorDefaultSkeletonComponent,
  TitlePageDefaultSkeletonComponent,
  TitleStepDefaultSkeletonComponent,
};
